<template>
  <div class="container-nzidoo">
    <div class="bg-white border rounded">
      <div class="row no-gutters">
        <div class="col-lg-4 col-xl-3">
          <div class="profile-content-left pt-5 pb-3 px-3 px-xl-5">
            <div class="card text-center widget-profile px-0 border-0">
              <div class="card-img mx-auto rounded-circle">
                <img v-bind:src="user.picture === null || user.picture === undefined
                  ? userpng
                  : config.storageUrl + user.picture
                  " alt="user image" />
              </div>
              <div>
                <h4 class="py-2 text-dark">
                  {{ user.firstname }} {{ user.lastname }}
                </h4>
                <p>{{ user.username }}</p>
                <p>{{ user.email }}</p>
              </div>
            </div>
            <hr class="w-100" />

          </div>
        </div>
        <div class="col-lg-8 col-xl-9">
          <div class="profile-content-right py-5">
            <ul class="nav nav-tabs px-3 px-xl-5 nav-style-border" id="myTab" role="tablist">
              <li class="nav-item" style="background: transparent !important;">
                <a class="nav-link active border-link-transparent" :class="activeTab == 'profile' ? 'active' : ''"
                  id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                  aria-selected="false">{{ $t("attr.profile") }}</a>
              </li>
              <li class="nav-item" style="background: transparent !important;">
                <a class="nav-link border-link-transparent" :class="activeTab == 'password' ? 'active' : ''"
                  id="password-tab" data-toggle="tab" href="#password" role="tab" aria-controls="password"
                  aria-selected="false">{{ $t("attr.password") }}</a>
              </li>
              <li class="nav-item" style="background: transparent !important;">
                <a class="nav-link border-link-transparent" :class="activeTab == 'client' ? 'active' : ''"
                  id="client-tab" data-toggle="tab" href="#client" role="tab" aria-controls="client"
                  aria-selected="false">
                  <label v-if="
                    user.roles != null && user.roles.includes('ROLE_CLIENT')
                  ">
                    {{ $t("sentence.clientInfo") }}
                  </label>
                  <label v-else>
                    {{ $t("sentence.becomeClient") }}

                    <label v-if="
                      user.validated_client == 0 && user.card_id !== null
                    ">
                      ({{ $t("sentence.requestSent") }})
                    </label>
                  </label>
                </a>
              </li>
              <li class="nav-item" style="background: transparent !important;">
                <a class="nav-link border-link-transparent" :class="activeTab == 'pro' ? 'active' : ''" id="pro-tab"
                  data-toggle="tab" href="#pro" role="tab" aria-controls="pro" aria-selected="false">
                  <label v-if="
                    user.roles != null && user.roles.includes('ROLE_SELLER')
                  ">
                    {{ $t("sentence.proInfo") }}
                  </label>
                  <label v-else>
                    {{ $t("sentence.becomePro") }}
                    <label v-if="user.validated_seller == 0 && user.rc != null">
                      ({{ $t("sentence.requestSent") }})
                    </label>
                  </label>
                </a>
              </li>
            </ul>
            <div class="tab-content px-3 px-xl-5 " id="myTabContent">
              <!-- Profile Tab -->
              <div class="tab-pane" :class="activeTab == 'profile' ? 'show active' : 'fade'" id="profile"
                role="tabpanel" aria-labelledby="profile-tab">
                <div class="tab-pane-content mt-5 width-100">
                  <form method="post" @submit.prevent="updateUser">
                    <div class="form-group row mb-6">
                      <label for="coverImage" class="col-sm-4 col-lg-2 col-form-label">{{ $t("main.userImage")
                      }}</label>
                      <div class="col-lg-8" :class="pictureOverview ? 'col-8' : 'col-10'">
                        <div class="custom-file mb-1">
                          <input type="file" v-bind:class="'custom-file-input' +
                          {
                            'is-invalid': has_error && errors.password,
                          }
                            " id="picture" name="picture" ref="picture" v-on:change="onPictureChange" />
                          <label class="custom-file-label" for="picture">{{ $t("action.chooseFile") }}...</label>
                        </div>
                      </div>
                      <div v-if="
                        pictureOverview !== false
                      " class="form-group col-4 col-lg-2 mb-5">
                        <div class="custom-file mb-1">
                          <img :src="pictureOverview !== ''
                            ? pictureOverview
                            : storageUrl + user.picture
                            " class="thumbnail mb-2" />
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="firstName">{{
                            $t("attr.firstname")
                          }}</label>
                          <input type="text" :class="'form-control ' +
                          {
                            'is-invalid': has_error && errors.firstName,
                          }
                            " id="firstName" v-model="userUpdate.firstname" />
                          <span class="help-block text-danger" v-if="has_error && errors.firstname">{{
                            errors.firstname[0] }}</span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="lastName">{{
                            $t("attr.lastname")
                          }}</label>
                          <input type="text" :class="'form-control ' +
                          {
                            'is-invalid': has_error && errors.lastName,
                          }
                            " id="lastName" v-model="userUpdate.lastname" />
                          <span class="help-block text-danger" v-if="has_error && errors.lastname">{{
                            errors.lastname[0] }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label for="username">{{ $t("attr.username") }}</label>
                      <input type="username" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.username,
                      }
                        " id="username" v-model="userUpdate.username" />
                      <span class="help-block text-danger" v-if="has_error && errors.username">{{ errors.username[0]
                      }}</span>
                    </div>

                    <div class="form-group mb-4">
                      <label for="email">{{ $t("attr.email") }}</label>
                      <input disabled type="email" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.email,
                      }
                        " id="email" v-model="userUpdate.email" />
                      <span class="help-block text-danger" v-if="has_error && errors.email">{{ errors.email[0]
                      }}</span>
                    </div>

                    <div class="form-group mb-4">
                      <label for="phone">{{ $t("attr.phone") }}</label>
                      <input type="text" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.phone,
                      }
                        " id="phone" v-model="userUpdate.phone" />
                      <span class="help-block text-danger" v-if="has_error && errors.phone">{{ errors.phone[0]
                      }}</span>
                    </div>

                    <div class="form-group mb-4">
                      <label for="birthday">{{ $t("attr.birthday") }}</label>
                      <input type="date" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.birthday,
                      }
                        " id="birthday" v-model="userUpdate.birthday" />
                      <span class="help-block text-danger" v-if="has_error && errors.birthday">{{ errors.birthday[0]
                      }}</span>
                    </div>

                    <div class="d-flex justify-content-center justify-content-md-end mt-5">
                      <button type="submit" class="btn btn-primary mb-2 btn-pill">
                        {{ $t("action.confirm") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <!-- Password Tab -->
              <div class="tab-pane" :class="activeTab == 'password' ? 'show active' : 'fade'" id="password"
                role="tabpanel" aria-labelledby="password-tab">
                <div class="tab-pane-content mt-5 width-100">
                  <form method="post" @submit.prevent="updatePassword">
                    <div class="form-group mb-4">
                      <label for="oldPassword">{{ $t("general.old") }}
                        {{ $t("attr.password") }}</label>
                      <input type="password" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.oldPassword,
                      }
                        " id="oldPassword" v-model="passwordData.oldPassword" />
                      <span class="help-block text-danger" v-if="has_error && errors.oldPassword">{{
                        errors.oldPassword[0] }}</span>
                    </div>

                    <div class="form-group mb-4">
                      <label for="newPassword">{{ $t("general.new") }}
                        {{ $t("attr.password") }}</label>
                      <input type="password" :class="'form-control ' +
                      {
                        'is-invalid': has_error && errors.newPassword,
                      }
                        " id="newPassword" v-model="passwordData.newPassword" />
                      <span class="help-block text-danger" v-if="has_error && errors.newPassword">{{
                        errors.newPassword[0] }}</span>
                    </div>

                    <div class="form-group mb-4">
                      <label for="conPassword">{{ $t("action.confirm") }}
                        {{ $t("attr.password") }}</label>
                      <input type="password" :class="'form-control ' +
                      {
                        'is-invalid':
                          has_error && errors.confirmPassword,
                      }
                        " id="confirmPassword" v-model="passwordData.confirmPassword" />
                      <span class="help-block text-danger" v-if="has_error && errors.confirmPassword">{{
                        errors.confirmPassword[0] }}</span>
                    </div>


                    <div class="d-flex justify-content-center justify-content-md-end mt-5">
                      <button type="submit" class="btn btn-primary mb-2 btn-pill">
                        {{ $t("action.confirm") }}
                      </button>
                    </div>
                  </form>
                  <div class="mb-2 pt-4 d-flex justify-content-center justify-content-md-end">
                    <button @click="showPopUpConfirmation(user.id)" class="btn btn-danger">
                      {{ $t("sentence.deleteAccount") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Client Tab -->
              <div class="tab-pane" :class="activeTab == 'client' ? 'show active' : 'fade'" id="client" role="tabpanel"
                aria-labelledby="client-tab">
                <div class="tab-pane-content mt-5 width-100">
                  <div class="row" v-if="userUpdate.validated_client !== 1">
                    <div v-if="userUpdate.card_id === null || userUpdate.card_id === undefined"
                      class="col-8 offset-2 text-center alert alert-info">
                      {{
                        $t("sentence.toBecomeAXPleaseFillUpTheInfo", {
                          subject: $t("actor.seller"),
                        })
                      }}
                    </div>
                    <div v-if="userUpdate.card_id !== null && userUpdate.card_id !== undefined"
                      class="col-8 offset-2 text-center alert alert-info">
                      {{
                        $t(
                          "sentence.yourRequestIsInProgressYouWillReceiveAnEmailSoon"
                        )
                      }}
                    </div>
                  </div>
                  <form method="post" id="updateUser" @submit.prevent="updateUser">
                    <div class="form-group mb-4">
                      <div class="col-lg-12">
                        <label for="address">{{ $t("attr.address") }}</label>
                        <input type="text" :class="'form-control ' +
                        {
                          'is-invalid': has_error && errors.address,
                        }
                          " id="address" v-model="userUpdate.address" />
                        <span class="help-block text-danger" v-if="has_error && errors.address">{{ errors.address[0]
                        }}</span>
                      </div>
                    </div>

                    <AddressSelector :errors="errors" :has_error="has_error" v-model="userUpdate" />

                    <div class="form-group mb-4">
                      <div class="col-lg-12">
                        <label for="postal_code">{{
                          $t("attr.postal_code")
                        }}</label>
                        <input type="text" :class="'form-control ' +
                        {
                          'is-invalid': has_error && errors.postal_code,
                        }
                          " id="postal_code" v-model="userUpdate.postal_code" />
                        <span class="help-block text-danger" v-if="has_error && errors.postal_code">{{
                          errors.postal_code[0] }}</span>
                      </div>
                    </div>
                    <div v-if="
                      cardIdOverview !== false ||
                      (user.cardId !== undefined &&
                        user.cardId !== null &&
                        user.cardId.length > 0)
                    " class="form-group row mb-6">
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <img :src="cardIdOverview !== ''
                            ? cardIdOverview
                            : storageUrl + user.cardId
                            " class="thumbnail" />
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mb-6">
                      <div class="col-lg-12">
                        <label for="cardId" class="col-sm-4 col-lg-2 col-form-label">{{ $t("ecommerce.cardId")
                        }}</label>
                        <div class="col-sm-8 col-lg-10">
                          <div class="custom-file mb-1">
                            <input type="file" :class="{
                              'is-invalid': has_error && errors.cardId,
                            }" id="cardId" name="cardId" ref="cardId" v-on:change="onCardIdChange" />
                            <label class="custom-file-label" for="cardId">{{ $t("action.chooseFile") }}...</label>
                            <span class="help-block text-danger" v-if="has_error && errors.cardId">{{ errors.cardId[0]
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center justify-content-md-end mt-5">
                      <button type="submit" class="btn btn-primary mb-2 btn-pill">
                        {{ $t("action.confirm") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <!-- Pro Tab -->
              <div class="tab-pane" :class="activeTab == 'pro' ? 'show active' : 'fade'" id="pro" role="tabpanel"
                aria-labelledby="pro-tab">
                <div class="tab-pane-content mt-5 width-100">
                  <div class="row" v-if="userUpdate.validated_seller !== 1">
                    <div v-if="
                      userUpdate.rc === undefined || userUpdate.rc === null
                    " class="col-8 offset-2 text-center alert alert-info">
                      {{
                        $t("sentence.toBecomeAXPleaseFillUpTheInfo", {
                          subject: $t("attr.professional"),
                        })
                      }}
                    </div>
                    <div v-if="
                      userUpdate.rc !== undefined && userUpdate.rc !== null
                    " class="col-8 offset-2 text-center alert alert-info">
                      {{
                        $t(
                          "sentence.yourRequestIsInProgressYouWillReceiveAnEmailSoon"
                        )
                      }}
                    </div>
                  </div>
                  <form method="post" id="updateUser" @submit.prevent="updateUser">
                    <div class="form-group mb-4">
                      <div class="col-lg-12">
                        <label for="address">{{ $t("attr.address") }}</label>
                        <input type="text" :class="'form-control ' +
                        {
                          'is-invalid': has_error && errors.address,
                        }
                          " id="address" v-model="userUpdate.address" />
                        <span class="help-block text-danger" v-if="has_error && errors.address">{{ errors.address[0]
                        }}</span>
                      </div>
                    </div>

                    <AddressSelector :errors="errors" :has_error="has_error" />

                    <div class="form-group mb-4">
                      <div class="col-lg-12">
                        <label for="postal_code">{{
                          $t("attr.postal_code")
                        }}</label>
                        <input type="text" :class="'form-control ' +
                        {
                          'is-invalid': has_error && errors.postal_code,
                        }
                          " id="postal_code" v-model="userUpdate.postal_code" />
                        <span class="help-block text-danger" v-if="has_error && errors.postal_code">{{
                          errors.postal_code[0] }}</span>
                      </div>
                    </div>
                    <div class="form-group row mb-6">
                      <div class="col-lg-12">
                        <label for="rc" class="col-sm-4 col-lg-2 col-form-label">{{ $t("ecommerce.rc") }}</label>
                        <div class="col-sm-8 col-lg-10">
                          <div class="custom-file mb-1">
                            <input type="file" class="custom-file-input" id="rc" name="rc" ref="rc"
                              v-on:change="onRcChange" />
                            <label class="custom-file-label" for="rc">{{ $t("action.chooseFile") }}...</label>
                            <span class="help-block text-danger" v-if="has_error && errors.rc">{{ errors.rc[0]
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="
                      rcOverview !== false ||
                      (userUpdate.rc !== undefined &&
                        userUpdate.rc !== null &&
                        typeof userUpdate.rc === 'string' &&
                        userUpdate.rc.length > 0)
                    " class="form-group row mb-6">
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <img :src="rcOverview !== false ? rcOverview : storageUrl + userUpdate.rc
                            " class="thumbnail" />
                        </div>
                      </div>
                    </div>

                    <div class="d-flex justify-content-center justify-content-md-end mt-5">
                      <button type="submit" class="btn btn-primary mb-2 btn-pill">
                        {{ $t("action.confirm") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <loading-spinner v-if="loader" />
      <notifications style="top:5%;" width="35%" group="success" position="top center" />
      <notifications style="top:5%;" width="35%" group="error" position="top center" />
      <v-dialog />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/config";
import AddressSelector from "@/components/templates/AddressSelector";
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';
import userpng from '@/assets/img/user/user.webp';
export default {
  data() {
    return {
      userpng:userpng,
      userUpdate: {},
      passwordData: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
      config: config,
      activeTab: "",
      cardIdOverview: false,
      rcOverview: false,
      pictureOverview: false,
      storageUrl: config.storageUrl,
    };
  },
  components: {
    AddressSelector,
    LoadingSpinner,
  },
  mounted() {
    this.userUpdate=Object.assign({}, this.user);
    if (this.userUpdate.birthday!==null&&this.userUpdate.birthday!==undefined) {
      this.userUpdate.birthday=moment(this.userUpdate.birthday, "YYYY-MM-DD").format("Y-MM-DD");
      this.user.birthday=moment(this.user.birthday, "YYYY-MM-DD").format("LL");
    }
    delete this.userUpdate.rc;
    delete this.userUpdate.picture;
    delete this.userUpdate.cardId;
    this.activeTab="profile";
    if (this.$route.params.activeTab!==undefined&&this.$route.params.activeTab!=="") {
      this.activeTab=this.$route.params.activeTab;
    }
  },
  methods: {
    onPictureChange() {
      this.userUpdate.picture=this.$refs.picture.files[0];
      this.pictureOverview=URL.createObjectURL(this.userUpdate.picture);
    },

    onRcChange() {
      this.userUpdate.rc=this.$refs.rc.files[0];
      this.rcOverview=URL.createObjectURL(this.userUpdate.rc);
    },

    onCardIdChange() {
      this.userUpdate.cardId=this.$refs.cardId.files[0];
      this.cardIdOverview=URL.createObjectURL(this.userUpdate.cardId);
    },

    updatePassword() {
      var self=this;
      this.loader=true;
      var formData=new FormData();
      window.scrollTo(0, 0);

      formData.append("oldPassword", self.passwordData.oldPassword||'');
      formData.append("newPassword", self.passwordData.newPassword||'');
      formData.append("confirmPassword", self.passwordData.confirmPassword||'');

      this.$axios({
        url: "user/update/"+self.user.id,
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log(response)
          self.loader=false;

          // Clear password fields after successful update
          self.passwordData.oldPassword='';
          self.passwordData.newPassword='';
          self.passwordData.confirmPassword='';

          // Clear errors
          self.has_error=false;
          self.errors={};

          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Mot de passe modifié avec succès!",
          });
        })
        .catch((err) => {
          self.loader=false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          self.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: "Une erreur est survenue !",
          });
          self.has_error=true;
          self.error=err.response.data.message;
          self.errors=err.response.data.data||{};
        });
    },

    updateUser() {
      var userUpdate=this.userUpdate;
      var self=this;
      this.loader=true;
      var formData=new FormData();
      window.scrollTo(0, 0);
      formData.append("username", self.userUpdate.username||'');
      formData.append("firstname", self.userUpdate.firstname||'');
      formData.append("lastname", self.userUpdate.lastname||'');
      formData.append("address", self.userUpdate.address||'');
      formData.append("city", self.userUpdate.city||'');
      
      formData.append("postal_code", self.userUpdate.postal_code||'');

      if (self.userUpdate.rc!==undefined&&self.userUpdate.rc!==null) {
        formData.append("rc", self.userUpdate.rc);
      }

      if (self.userUpdate.picture!==undefined&&self.userUpdate.picture!==null) {
        formData.append("picture", self.userUpdate.picture);
      }

      if (self.userUpdate.cardId!==undefined&&self.userUpdate.cardId!==null) {
        formData.append("card_id", self.userUpdate.cardId);
      }

      if (self.userUpdate.phone!==undefined&&self.userUpdate.phone!==null) {
        formData.append("phone", self.userUpdate.phone);
      }

      if (self.userUpdate.birthday!==undefined&&self.userUpdate.birthday!==null) {
        formData.append("birthday", self.userUpdate.birthday);
      }

      if (self.userUpdate.commune!==undefined&&self.userUpdate.commune!==null) {
        formData.append("commune", self.userUpdate.commune);
      }

      this.$axios({
        url: "user/update/"+userUpdate.id,
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          self.loader=false;

          // Update Vuex store with new user data
          if (response.data&&response.data.data) {
            self.$store.commit("setUser", { user: response.data.data });
          } else {
            // If API doesn't return updated user, update with local data
            const updatedUser=Object.assign({}, self.user, self.userUpdate);
            self.$store.commit("setUser", { user: updatedUser });
          }

          // Clear errors
          self.has_error=false;
          self.errors={};

          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Profil modifié avec succès!",
          });
        })
        .catch((err) => {
          self.loader=false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          self.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: "Une erreur est survenue !",
          });
          self.has_error=true;
          self.error=err.response.data.message;
          self.errors=err.response.data.data||{};
        });
    },
    showPopUpConfirmation(userId) {
      var self=this;
      this.$modal.show("dialog", {
        title: "Confirmation",
        text:
          "<label class='color-red'>Attention ! </label> En supprimant votre compte sur Nzidoo, toutes vos annonces passées et à venir seront supprimées ainsi que votre profil. Un compte supprimè est définitivement perdu",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              self.$modal.hide("dialog");
              return false;
            },
          },
          {
            title: "Confirmer",
            handler: () => {
              self.deleteAccount(userId);
              self.$modal.hide("dialog");
            },
          },
        ],
      });
    },
    deleteAccount(userId) {
      var self=this;
      self.loader=true;

      this.$axios({
        url: "user/remove/"+userId,
        method: "POST",
      })
        .then(() => {
          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Utilisateur supprimé avec succès!",
          });
          self.loader=false;
          self.logout();
        })
        .catch((err) => {
          self.loader=false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          self.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: "Une erreur est survenue !",
          });
          self.has_error=true;
          self.error=err.response.data.message;
          self.errors=err.response.data.data||{};
        });
    },
    scrollToClass(className) {
      var el=this.$el.getElementsByClassName(className)[0];
      el.scrollIntoView({ behavior: "smooth" });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
  },
};
</script>

<style scoped>
.border-link-transparent {
  border: transparent !important;
}
</style>